import './index.css';

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import ReactDOM from 'react-dom/client';

import App from './App';
import { isApiUnreachableError, MAX_API_RETRIES } from './api/apiErrors';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Only retry when the API couldn't be reached; business/server errors won't fix themselves.
      retry: (failureCount, error) =>
        isApiUnreachableError(error) && failureCount < MAX_API_RETRIES,
      // Once retries run out, hand the error to ApiErrorBoundary to show the unavailable page.
      throwOnError: (error) => isApiUnreachableError(error),
    },
  },
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <QueryClientProvider client={queryClient}>
    <App />
  </QueryClientProvider>
);
